"use client";

import { FaWhatsapp } from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";
import { useState, useEffect } from "react";
import { usePathname } from "next/navigation";

export default function WhatsAppButton() {
  const [showTooltip, setShowTooltip] = useState(false);
  const pathname = usePathname();

  useEffect(() => {
    const timer = setTimeout(() => setShowTooltip(true), 3000);
    return () => clearTimeout(timer);
  }, []);

  if (pathname?.startsWith("/admin")) return null;

  return (
    <div className="fixed bottom-6 right-6 z-[99] flex flex-col items-end gap-2">
      <AnimatePresence>
        {showTooltip && (
          <motion.div
            initial={{ opacity: 0, y: 10, scale: 0.9 }}
            animate={{ opacity: 1, y: 0, scale: 1 }}
            exit={{ opacity: 0, scale: 0.9 }}
            className="bg-white text-gray-800 px-4 py-2 rounded-2xl shadow-xl border border-gray-100 text-sm font-semibold mb-2 mr-2 relative"
          >
            Chat with us!
            <div className="absolute -bottom-1 right-5 w-3 h-3 bg-white rotate-45 border-b border-r border-gray-100"></div>
          </motion.div>
        )}
      </AnimatePresence>

      <div className="relative flex items-center justify-center">
        <span className="absolute -inset-2 rounded-full bg-green-400 opacity-50 blur-lg animate-pulse"></span>
        <span className="absolute -inset-1 inline-flex h-full w-full animate-ping rounded-full bg-green-400 opacity-20"></span>

        <motion.a
          href="https://wa.me/919470771245"
          target="_blank"
          rel="noopener noreferrer"
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          whileHover={{ 
            scale: 1.1, 
            rotate: 5,
            boxShadow: "0px 0px 25px rgba(34, 197, 94, 0.6)" 
          }}
          whileTap={{ scale: 0.9 }}
          className="relative bg-green-500 text-white p-4 rounded-full shadow-2xl flex items-center justify-center transition-colors duration-300 hover:bg-green-600"
          aria-label="Chat on WhatsApp"
        >
          <FaWhatsapp className="text-3xl" />
        </motion.a>
      </div>
    </div>
  );
}